import { DayOfWeek } from '@leid/api-locations'
import { format } from 'date-fns'
import moment, { Moment } from 'moment'

export const buildUtcDateString = (date: Date | null, hours: string | null): string => {
  const result = buildDate(date, hours).toISOString()
  return result
}

export const buildDate = (date: Date | null, hours: string | null): Date => {
  const result = new Date(`${date?.toDateString()} ${hours ?? '00'}:00:00`)
  return result
}

export function utcNowMoment(): moment.Moment {
  return moment.utc()
}

export function utcNow(): Date {
  const utcMomentNow = utcNowMoment()
  return utcMomentNow.toDate()
}

export function parseUtcToMoment(dateUtc: Date | undefined): Moment | undefined {
  if (!dateUtc) {
    return undefined
  }
  return moment.utc(dateUtc)
}

export function parseToMoment(dateUtc: Date | undefined): Moment | undefined {
  if (!dateUtc) {
    return undefined
  }
  return moment(dateUtc)
}

export const transformHoursToTwoDigitsString = (hours: number): string => {
  return hours < 10 ? `0${hours}` : hours.toString()
}

export const parseDayOfWeek = (dayNumber: number): DayOfWeek => {
  switch (dayNumber) {
    case 0:
      return DayOfWeek.SUNDAY
    case 1:
      return DayOfWeek.MONDAY
    case 2:
      return DayOfWeek.TUESDAY
    case 3:
      return DayOfWeek.WEDNESDAY
    case 4:
      return DayOfWeek.THURSDAY
    case 5:
      return DayOfWeek.FRIDAY
    case 6:
      return DayOfWeek.SATURDAY
  }

  return DayOfWeek.MONDAY
}

export const getDifferenceInHours = (from: Date, to: Date): number => {
  const momentFrom = moment(from)
  const momentTo = moment(to)

  const duration = moment.duration(momentTo.diff(momentFrom))
  return duration.asHours()
}

export const pretifyDate = (date: Date | string | null) => {
  if (date == null) {
    return null
  }
  if (typeof date === 'string') {
    date = new Date(date)
  }
  return format(date, 'dd/MM/yyyy HH:mm')
}
